export const SITE_TYPE_DAM = 'dam';
export const SITE_TYPE_RIVER = 'river';
export const SITE_TYPE_TRIBUTARY = 'tributary';
export const SITE_TYPE_TIDE = 'tide';
export const SITE_TYPE_TIDE_FORECAST = 'tide_forecast';

export const SITE_TYPE_CATEGORY_RIVERINE = [SITE_TYPE_DAM, SITE_TYPE_RIVER, SITE_TYPE_TRIBUTARY];
export const SITE_TYPE_CATEGORY_OCEAN = [SITE_TYPE_TIDE, SITE_TYPE_TIDE_FORECAST];

export const RIVER_FLOOD_TYPE_MINOR = 'minor';
export const RIVER_FLOOD_TYPE_MODERATE = 'moderate';
export const RIVER_FLOOD_TYPE_MAJOR = 'major';

export const MAP_MARKER_ANCHOR_LEFT = 'left';
export const MAP_MARKER_ANCHOR_RIGHT = 'right';
export const MAP_MARKER_ANCHOR_TOP = 'top';
export const MAP_MARKER_ANCHOR_BOTTOM = 'bottom';

export const STATES_SITE_STATE_NO_RECENT_DATA = 'no_recent_data';
export const STATES_SITE_STATE_NO_CHANGE = 'no_change';

export const STATES_TREND_RISING = 'rising';
export const STATES_TREND_FALLING = 'falling';
export const STATES_TREND_STEADY = 'steady';

export const STATES_GATE_STATE_OPEN = 'open';
export const STATES_GATE_STATE_FULLY_OPEN = 'fully_open';
export const STATES_GATE_STATE_CLOSED = 'closed';

export const HEIGHT_UNIT_METERS = 'meters';
